export function stringHashCode(s: string) {
  let h = 0;

  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i);
  }

  return Math.abs(h);
}
